import { Box as ChakraBox } from "@chakra-ui/react";

export const Box = ChakraBox;

/**
 * @typedef {import("react").ComponentProps<Box>} BoxProps
 */
